<div class="px-3 pt-3">
    <ng-container *ngTemplateOutlet="data.Label"></ng-container>
</div>
<mat-nav-list class="px-1">
    @for (item of data.Options; track item.itemQueryList; let ind = $index) {
        @if (item.itemQueryList.length > 1) {
            <a mat-list-item
                class="scss-disable-mat-selected"
                (click)="SelectAll(item, ind, !item.form.controls.SelectAll.value)">
                <lib-checkbox [formControl]="item.form.controls.SelectAll" [isIndeterminate]="item.isIndeterminate"
                    (change)="SelectAll(item, ind, $event)"
                    [checked]="item.isAllSelected">
                    {{item.selectAllLabel}}
                    ({{item.itemQueryList.length}})
                </lib-checkbox>
            </a>
        }
        @for (checkbox of item.itemQueryList; track checkbox.value; let i = $index) {
            <a mat-list-item
                class="scss-disable-mat-selected"
                (click)="ChangeEvent(item, ind, !item.viewControl.controls[i].value, i)">
                <lib-checkbox [ngClass]="{'padding-left-28': item.itemQueryList.length > 1}"
                    [formControl]="item.viewControl.controls[i]"
                    [isLoading]="item.isLoading"
                    [checked]="item.viewControl.controls[i].value"
                    [qaTag]="checkbox.qaTag"
                    (change)="ChangeEvent(item, ind, $event, i)">
                    <ng-container *ngTemplateOutlet="checkbox.label"></ng-container>
                </lib-checkbox>
            </a>
        }
    }
</mat-nav-list>